import React from "react";
import { Header } from "../../../components/Header";
import "./style.css";
import { getAnalytics, logEvent } from "firebase/analytics";

const ComingLater = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'comingsoon');
  return (
    <div className="coming-later">
      <div className="main-content">
      <div className="div">
        <div className="div-2">
          <div className="div-2">
            <div className="overlap-group">
              <img className="ellipse" alt="Ellipse" src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2Fellipse-10.svg?alt=media&token=a8d492d0-b40e-4eb8-a03a-a14013195191" />
              <img className="img" alt="Vector" src="https://c.animaapp.com/plW1NP4c/img/vector-6.svg" />
              <div className="ellipse-2" />
              <div className="ellipse-3" />
            </div>
          </div>
          <p className="p">An diesem Feature arbeiten wir gerade noch!</p>
          <div className="text-wrapper-2">Bitte habe etwas Geduld.</div>
        </div>
        <Header
          className="header-instance"
        />
      </div>
    </div>
    <div className="mobile-warning">
      Bitte drehen Sie ihr Gerät.<img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FturnLandscape.png?alt=media&token=5c863abc-d04b-4bb1-9639-53b4056b88f5"></img>
    </div>
    </div>
  );
};

export default ComingLater;